import { useAppSelector } from "@/services/store";
import { contactsIsEditSelector, currentPersonSelector } from "@/pages/ContactsPage/slice";
import { ContactsPersonCard } from "../../ContactsPersonCard";
import { AdditionalInfo, TagsField, TitleField } from "../../Fields";
import { LeftSectionList } from "../../LeftSectionList";
import { RightSectionList } from "../../RightSectionList";
import styles from "./styles.module.scss";

export const LayoutDesktop = () => {
  const contactsIsEdit = useAppSelector(contactsIsEditSelector);
  const currentPerson = useAppSelector(currentPersonSelector);

  const getAvatarIsEditable = () => {
    if (!contactsIsEdit) return false;
    if (currentPerson?.id.includes("new")) return false;
    return true;
  };

  return (
    <div className={styles.root}>
      <div className={styles["left-section"]}>
        <div className={styles.card}>
          <TagsField />
          <div className={styles.person}>
            <ContactsPersonCard avatarIsEditable={getAvatarIsEditable()} />
          </div>
          <div className={styles["info-fields"]}>
            <TitleField />
            <AdditionalInfo />
          </div>
        </div>
        <div className={styles["left-section-data-lists"]}>
          <LeftSectionList />
        </div>
      </div>
      <div className={styles["right-section"]}>
        <RightSectionList />
      </div>
    </div>
  );
};
